export default function TotalResumen({
  precioBase,
  cantidad,
  extrasTotal,
  personalizarCadaUno,
}) {
  const total = precioBase * cantidad + extrasTotal;

  return (
    <div className="bg-[#0f0f0f] border border-white/10 rounded-xl p-4">
      <p className="text-sm text-gray-300">
        Precio base: ${precioBase.toLocaleString("es-CO")}
      </p>

      <p className="text-sm text-gray-300">
        Extras: ${extrasTotal.toLocaleString("es-CO")}
      </p>

      <p className="font-bold text-orange-400 text-lg">
        Total: ${total.toLocaleString("es-CO")}
      </p>

      {personalizarCadaUno && (
        <p className="text-xs text-gray-400 mt-1">
          Total calculado por unidad
        </p>
      )}
    </div>
  );
}
